<template>
  <v-container grid-list-xl>
    <v-layout
      wrap
      justify-space-between
      v-if="finished"
    >
      <v-flex
        xs12
        md12
      >
          <h1>Password Change Successful</h1>
          <v-btn :to="`/`">OK</v-btn>
      </v-flex>
    </v-layout>
    <v-layout
      wrap
      justify-space-between
      v-if="!finished"
    >
      <v-flex
        xs12
        md12
      >
          <h1>Change Password</h1>
      </v-flex>
      
      <v-flex
        xs12
        md12
      >
        <v-form ref="form">
          <v-text-field
            v-model="old_password"
            :rules="[rules.reasonable_length]"
            :error-messages="old_password_error_messages"
            label="Old Password"
          ></v-text-field>
          <v-text-field
            v-model="new_password"
            :rules="[rules.reasonable_length]"
            :error-messages="new_password_error_messages"
            label="New Password"
          ></v-text-field>
          <v-text-field
            v-model="confirm_password"
            :rules="[rules.reasonable_length]"
            :error-messages="confirm_password_error_messages"
            @input = "confirm_password_error_messages = []"
            label="Confirm New Password"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-btn color="primary" @click="confirm">Change Password</v-btn>
      <br/>
      주의: 당신이 설정하는 패스워드는 수십만원을 지불한 당신의 티켓을 보호합니다. 용도에 적합한 패스워드를 설정하세요.
      <br/>
      Remember: Your password protects tickets worth hundreds of dollars.  Pick a decent one.
    </v-layout>

  </v-container>
</template>

<script>
export default {
  props: ['auth'],
  data: () => ({
    old_password: '',
    old_password_error_messages: [],
    new_password: '',
    new_password_error_messages: [],
    confirm_password: '',
    confirm_password_error_messages: [],
    rules: {
      required: value => !!value || 'Required.',
      reasonable_length: value =>
        (value.length >= 8 && value.length < 32) || 'At least 8 characters',
    },
    finished: false,
  }),
  methods: {
    confirm: async function({router}) {
      if (this.$data.new_password != this.$data.confirm_password) {
        this.$data.confirm_password_error_messages =
          'Password Confirmation Does Not Match';
        return false;
      }
      if (this.$refs.form.validate()) {
        var res = await this.auth.change_password(
          this.$data.old_password,
          this.$data.new_password,
        );
        console.log('check result', res);
        if (!res.data.success) {
          this.old_password_error_messages = res.data.message;
        } else {
          this.finished = true;
        }
      }
    },
    uncheck() {
      this.phone_validated = false;
    },
  },
};
</script>
